import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import MediaContent from "modules/Media";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const MediaPage: React.FC = () => {
  setTitle("Media Management");
  return (
    <Auth>
      <Layout>
        <MediaContent />
      </Layout>
    </Auth>
  );
};

export default MediaPage;
